var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "iframe-container"
  }, [_vm.showBgDv ? _c('div', {
    staticClass: "iframe-cover",
    style: _vm.iframeCoverStyle
  }, [!_vm.hasBase64 && _vm.coverImg ? _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": _vm.coverImg
    }
  }) : _vm._e()]) : _vm._e(), _vm.isShowIframe ? _c('div', {
    style: _vm.iframeStyle
  }, [_c('iframe', {
    ref: "iframeRef",
    staticClass: "iframe-style",
    attrs: {
      "id": 'IframeItem' + _vm.index,
      "scrolling": "no",
      "frameborder": "0"
    }
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };